<div class="waec-page-header">
	<img class="waec-page-header-image" src="/assets/icons/Recovery_highlighted.svg" alt="Highighted_recovery"/>
	<h3 class="waec-page-header-text">Recover Candidate Number</h3>
</div>
<div class="page-container" nz-row>
    <div class="myCert" id="myCert">
      <nz-card [nzBordered]="false" class="ant-card-body-main">
        <div
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="16"
          nzXl="16"
          class="verification_form"
        >
          <h6 class="waec-card-header-text mb-5">Recover Your Candidate Number</h6>
          <div class="py-3">
            <p class="recover-no-label"> 
                Below is the recovered information for: <br><span class="candidate-name">{{surname}}  {{firstname}} ({{exam_name}} - {{year}})</span>
            </p>
          </div>
        </div>
        <div nz-row class="myCert-container">
          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
            <div nz-row class="row-gutter">
              <div class="cert-container">
                <img  class="waec-badge" src="/assets/icons/Recovery.svg" title="Recovered Candidate Number"  alt="Recovery" />
                <div class="cert-wrapper">
                  <div class="inner-wrapper">
                    <div class="content-wrapper">
                      <div class="content-subheader-wrapper">
                        <p class="candidate-number-text">
                         CANDIDATE NUMBER:
                        </p>
                        <p class="content-examNo-text">
                          {{ candidate_number }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="candidate_details?.wallet_history_id" >
          <p class="span-left">Would you like to access your certificate now? Click Below</p>
          <a (click)="backToAccess()"><button class="btn-sm btn-primary">ACCESS CERTIFICATE</button></a>
        </div>
        </nz-card>
    </div>
  </div>


<!-- MODE OF PAYMENT Information -->
<nz-modal
[nzStyle]="{ top: '20px' }"
[nzMask]="true"
nzMaskClosable="false"
nzWidth="400px"
nzClosable="true"
[(nzVisible)]="paymentModal"
nzTitle="Payment Options"
[nzContent]="modalContentPaymentOptions"
(nzOnCancel)="cancelPaymentOptionsModal()"
>
<ng-template #modalContentPaymentOptions>
  <app-payment
    (confirmSubmit)="initiateWallet($event)"
    actions="access"
    [Cost]="retrievalCost"
  ></app-payment>
</ng-template>
<div *nzModalFooter></div>
</nz-modal>

<!-- Wallet Credit -->
<nz-modal
[nzStyle]="{ top: '20px' }"
[nzMask]="true"
nzMaskClosable="false"
nzWidth="400px"
nzClosable="true"
[(nzVisible)]="walletCreditModal"
nzTitle="Fund Wallet"
[nzContent]="modalContentbillingpayment"
(nzOnCancel)="cancelmodalContentbillingpayment()"
>
<ng-template #modalContentbillingpayment>
  <app-billing-modal
    (successResponse)="initiateFundingWallet($event)"
    [Cost]="retrievalCost"
  ></app-billing-modal>
</ng-template>
<div *nzModalFooter></div>
</nz-modal>